/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loan amount`)
};

const es_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad de préstamo`)
};

const de_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darlehensbetrag`)
};

const nl_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leningbedrag`)
};

const fr_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant du prêt`)
};

const it_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo del prestito`)
};

const pt_br2_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montante do empréstimo`)
};

const pt_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montante do empréstimo`)
};

const ja_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「ローン金額」`)
};

const zh_ln_principal_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贷款金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_principal_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_principal_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_principal_label", locale)
	if (locale === "en") return en_ln_principal_label(inputs)
	if (locale === "es") return es_ln_principal_label(inputs)
	if (locale === "de") return de_ln_principal_label(inputs)
	if (locale === "nl") return nl_ln_principal_label(inputs)
	if (locale === "fr") return fr_ln_principal_label(inputs)
	if (locale === "it") return it_ln_principal_label(inputs)
	if (locale === "pt-BR") return pt_br2_ln_principal_label(inputs)
	if (locale === "pt") return pt_ln_principal_label(inputs)
	if (locale === "ja") return ja_ln_principal_label(inputs)
	return zh_ln_principal_label(inputs)
};